module.exports = __webpack_public_path__ + "img/preview.80c27ab0.jpg";